/**
 * The below file contains the fire agency state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_FIRE_AGENCY,
} from "redux/constants/FireAgency";

//Initial state
const initState = {
  // Keys for dropdown 
  fireAgencies: [],
  isFireAgencyDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const fireAgency = (state = initState, action) => {
  switch (action.type) {
    //Cases for Fire agency dropdown
    case SET_ALL_FIRE_AGENCY:
      return {
        ...state,
        fireAgencies: action.payload,
        isFireAgencyDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Fire agency dropdown

    default:
      return state;
  }
};

export default fireAgency;
